import { EMPTY_OBJECT, EMPTY_STRING } from '../../constants/common'
import {
  filterPermittedActionsWithDividers,
  parseActionsOnValidDivider,
} from '../../utils/massActions'
import { isSubArchive } from '../../utils/route'

import {
  BUILDINGS_ACTION_ARCHIVE,
  BUILDINGS_ACTION_ARCHIVE_MASS,
  BUILDINGS_ACTION_EDIT_BUILDINGS_GROUP,
  BUILDINGS_ACTION_EDIT_BUILDINGS_GROUP_MASS,
  BUILDINGS_ACTION_EDIT_MANAGERS,
  BUILDINGS_ACTION_EDIT_MANAGERS_MASS,
  BUILDINGS_ACTION_EDIT_PROPERTY_OWNERS,
  BUILDINGS_ACTION_EDIT_PROPERTY_OWNERS_MASS,
  BUILDINGS_ACTION_REMOVE,
  BUILDINGS_ACTION_REMOVE_MASS,
  BUILDINGS_ACTION_RESTORE,
  BUILDINGS_ACTION_RESTORE_MASS,
} from './Building.constants'

export function toBuildingSelectItem(item) {
  return {
    ...(item.label?.avatar ? { avatar: { src: item.label.avatar } } : null),
    label: item.label?.title || item.address_obj?.value,
    value: item.value,
  }
}

export function toBuildingSelectItems(items, mapper = toBuildingSelectItem) {
  return items.map(mapper)
}

export function toBuildingTypeSelectItem(item) {
  return {
    label: item.value,
    value: item.id,
  }
}

export function toBuildingTypeSelectItems(
  items,
  mapper = toBuildingTypeSelectItem
) {
  return items.map(mapper)
}

export function toBuildingInsuranceTypeSelectItem(item) {
  return {
    label: item.value,
    value: item.id,
  }
}

export function toBuildingInsuranceTypeSelectItems(
  items,
  mapper = toBuildingInsuranceTypeSelectItem
) {
  return items.map(mapper)
}

export function toInhabitantBuildingSelectItem(item = EMPTY_OBJECT) {
  return {
    label: item.title || EMPTY_STRING,
    value: item.id,
  }
}

export function toBuildingAddressSelectItem(item = EMPTY_OBJECT) {
  return {
    label: item.address?.value || item.address || EMPTY_STRING,
    value: item.id,
  }
}

export function toBuildingAddressSelectItems(
  items,
  mapper = toBuildingAddressSelectItem
) {
  return items.map(mapper)
}

export function getBuildingItemActions({ permissions }) {
  const items = [
    {
      label: 'Building.EditBuildingsGroupActionOptionKey',
      permission: permissions.can_edit_building_group,
      value: BUILDINGS_ACTION_EDIT_BUILDINGS_GROUP,
    },
    {
      label: 'Building.EditManagersActionOptionKey',
      permission: permissions.can_edit_responsible_user,
      value: BUILDINGS_ACTION_EDIT_MANAGERS,
    },
    {
      label: 'Building.EditPropertyOwnersActionOptionKey',
      permission: permissions.can_edit_property_owner,
      value: BUILDINGS_ACTION_EDIT_PROPERTY_OWNERS,
    },
    {
      label: 'Building.RemoveActionOptionKey',
      permission: permissions.can_remove,
      value: BUILDINGS_ACTION_REMOVE,
    },
    null,
    {
      label: 'Building.ArchiveActionOptionKey',
      permission: permissions.can_archive,
      value: BUILDINGS_ACTION_ARCHIVE,
    },
    {
      label: 'Building.RestoreActionOptionKey',
      permission: permissions.can_restore,
      value: BUILDINGS_ACTION_RESTORE,
    },
  ]

  return parseActionsOnValidDivider(filterPermittedActionsWithDividers(items))
}

export function getBuildingMassActions({ permissions, sub, t }) {
  const items = [
    {
      label: t('Building.EditBuildingsGroupActionOptionKey'),
      permission: permissions.can_edit_building_group && !isSubArchive(sub),
      value: BUILDINGS_ACTION_EDIT_BUILDINGS_GROUP_MASS,
    },
    {
      label: t('Building.EditManagersActionOptionKey'),
      permission: permissions.can_edit_responsible_user && !isSubArchive(sub),
      value: BUILDINGS_ACTION_EDIT_MANAGERS_MASS,
    },
    {
      label: t('Building.EditPropertyOwnersActionOptionKey'),
      permission: permissions.can_edit_property_owner && !isSubArchive(sub),
      value: BUILDINGS_ACTION_EDIT_PROPERTY_OWNERS_MASS,
    },
    {
      label: t('Building.RemoveActionOptionKey'),
      permission: permissions.can_edit && !isSubArchive(sub),
      value: BUILDINGS_ACTION_REMOVE_MASS,
    },
    null,
    {
      label: t('Building.ArchiveActionOptionKey'),
      permission: permissions.can_archive && !isSubArchive(sub),
      value: BUILDINGS_ACTION_ARCHIVE_MASS,
    },
    {
      label: t('Building.RestoreActionOptionKey'),
      permission: permissions.can_restore && isSubArchive(sub),
      value: BUILDINGS_ACTION_RESTORE_MASS,
    },
  ]

  return parseActionsOnValidDivider(filterPermittedActionsWithDividers(items))
}
